$(function(){
	$(document).on("click", "[data-slide-to-content]", function(){
		let id = $(this).attr('data-slide-to-content');
		$('html,body').animate({
	        scrollTop: $(id).offset().top
	    }, 'slow');
	});

	$(document).on("click", ".scrollDown", function(){
        let crollToTop = $('#section_welcome').position().top - 85;
		$('html,body').animate({
	        scrollTop: crollToTop
	    }, 'slow');
	})
});